const routerViewMap = {
    Home: () => import('@/views/Home/HomeIndex'),
    Dashboard: () => import('@/views/Home/Dashboard/Dashboard'),
    /*  */
    Equipment: () => import('@/views/Equipment/EquipmentIndex'),
    /*  */
    System: () => import('@/views/System/SystemIndex'),
    User: () => import('@/views/System/User/User'),
    Menu: () => import('@/views/System/Menu/Menu'),
    Role: () => import('@/views/System/Role/Role'),
    RestTime: () => import('@/views/System/RestTime/RestTime'),
    /* 日志 */
    Log: () => import('@/views/Log/LogIndex'),
    LoginInfor: () => import('@/views/Log/logininfor/LoginInfor'),
    OperLog: () => import('@/views/Log/OperLog/OperLog'),
    Basic: () => import('@/views/Basic/BasicIndex'),
    Station: () => import('@/views/Basic/Station/Station'),
    ProductionLine: () => import('@/views/Basic/ProductionLine/ProductionLine'),
    Workshop: () => import('@/views/Basic/Workshop/Workshop'),
    Config: () => import('@/views/Basic/Config/Config'),
    Cause: () => import('@/views/Basic/Cause/Cause'),
    Simple: () => import('@/views/Basic/Simple/Simple'),
    Schedule: () => import('@/views/Basic/Schedule/Schedule'),
    Statistics: () => import('@/views/Statistics/StatisticsIndex'),
    Board: () => import('@/views/Statistics/Board/Board'),
    TimeoutDetail: () => import('@/views/Statistics/TimeoutDetail/TimeoutDetail'),
    Timeout: () => import('@/views/Statistics/Timeout/Timeout'),
    ProStopDetail: () => import('@/views/Statistics/ProStopDetail/ProStopDetail'),
    StationStopDetail: () => import('@/views/Statistics/StationStopDetail/StationStopDetail'),
    StationStopHz: () => import('@/views/Statistics/StationStopHz/StationStopHz'),
    StationStopHzRatio: () => import('@/views/Statistics/StationStopHzRatio/StationStopHzRatio'),
    StationStopTime: () => import('@/views/Statistics/StationStopTime/StationStopTime'),
    StationStopTimeRatio: () => import('@/views/Statistics/StationStopTimeRatio/StationStopTimeRatio'),
    StartRate: () => import('@/views/Statistics/StartRate/StartRate')
}
export default (key) => {
  return routerViewMap[key] || null
}
